import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const usePortfolioProfileRoles = (portfolioUuid: string, profileUuid: string) => {
  const middleman = useMiddleman();
  return useQuery(['portfolioProfileRoles', portfolioUuid, profileUuid], () => {
    return middleman.get(`/ql/crm/roles/${portfolioUuid}/${profileUuid}`).then((res) => {
      return res.data;
    });
  }, {
    enabled: !!portfolioUuid && !!profileUuid,
  });
};